<template>
  <Layout>
    <div class="about-page">
      <section class="hero">
        <div class="hero-panel">
          <h1>
            "You can't buy happiness, but you can buy a bagel, and that's pretty
            close."
          </h1>
          <p class="quote-credit">- Unknown</p>
        </div>
      </section>

      <section class="story-section">
        <div class="image-panel">
          <img src="/ellen_chris.jpeg" alt="Chris and Ellen" />
        </div>

        <div class="copy-panel">
          <p class="eyebrow">The Master Bakers</p>
          <h2>Ellen and Chris built Beam Me Up Bagels one bagel at a time.</h2>
          <p>
            Owners Ellen and Chris have been crafting bagels for more than 10
            years, and what a 10 years it has been. From humble beginnings at
            the farmers market, they have grown Beam Me Up Bagels into the
            much-loved bagel shop it is today.
          </p>
        </div>
      </section>

      <section class="team-section">
        <div class="copy-panel">
          <p class="eyebrow">The Team</p>
          <h2>A great team behind every bagel.</h2>
          <p>
            Alongside Ellen and Chris is a wonderful team across both stores who
            enjoy the bagels just as much as they do. When you visit Beam Me Up
            Bagels, you will always find a happy, smiley face ready to welcome
            you in.
          </p>
        </div>
        <div class="team-image-panel">
          <!-- img tag here -->
        </div>
      </section>

      <section class="timeline-section">
        <div class="section-heading">
          <p class="eyebrow">Our Journey</p>
          <h2>From market mornings to two local favourites.</h2>
        </div>

        <div class="timeline-grid">
          <article
            class="timeline-card"
            v-for="(section, index) in sections"
            :key="index"
          >
            <img
              :src="section.image"
              :alt="section.title"
              class="timeline-image"
            />
            <div class="timeline-copy">
              <p class="timeline-step">0{{ index + 1 }}</p>
              <h3>{{ section.title }}</h3>
              <p>{{ section.description }}</p>
            </div>
          </article>
        </div>
      </section>
    </div>
  </Layout>
</template>

<script>
import Layout from "./Layout.vue";

export default {
  data() {
    return {
      sections: [
        {
          title: "Founded Beam Me Up Bagels",
          description:
            "The journey began in 2014 with early mornings at the farmers market and a table full of fresh bagels.",
          image: "/1396.JPEG",
        },
        {
          title: "A Home in North East Valley",
          description:
            "In 2018, the first Beam Me Up Bagels store opened in North East Valley and quickly found a loyal local following.",
          image: "/nevsunny.jpg",
        },
        {
          title: "Bagels in the City",
          description:
            "By 2020, things were firmly on a roll and a second store opened in the city.",
          image: "/city.jpg",
        },
        {
          title: "What's Next?",
          description:
            "We are always looking to the future, and have some exciting plans in the works. Watch this space!",
          image: "/spock.jpg",
        },
      ],
    };
  },
  components: {
    Layout,
  },
};
</script>
<style scoped lang="scss">
.about-page {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 5rem 5rem;
  color: var(--text-colour);
}

.eyebrow {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--action-colour);
}

.hero-panel,
.image-panel,
.copy-panel,
.team-image-panel,
.timeline-card {
  border: 1px solid var(--secondary-colour);
  border-radius: 1.5rem;
  overflow: hidden;
}

.hero {
  .hero-panel {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    min-height: 20rem;
    padding: 1.75rem 2rem;
    background-color: var(--secondary-colour);
    background-image: linear-gradient(
        180deg,
        transparent 0%,
        var(--primary-colour) 100%
      ),
      url("../../public/bagels_racked.jpeg");
    background-size: cover;
    background-position: center;

    .quote-credit {
      margin: 0;
      font-size: 1rem;
      color: var(--action-colour);
    }
  }
}

.story-section {
  display: grid;
  grid-template-columns: minmax(0, 0.55fr) minmax(0, 1fr);
  gap: 2rem;
  align-items: stretch;

  .image-panel {
    min-height: 26rem;
    background-color: var(--secondary-colour);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
      display: block;
    }
  }

  .copy-panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    padding: 2.5rem;
    background: linear-gradient(
      180deg,
      var(--secondary-colour) 0%,
      var(--primary-colour) 100%
    );

    p:not(.eyebrow) {
      margin: 0;
      font-size: 1.1rem;
      line-height: 1.8;
      color: var(--text-colour);
    }
  }
}

.team-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.55fr);
  gap: 2rem;
  align-items: stretch;

  .copy-panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    padding: 2.5rem;
    background: linear-gradient(
      180deg,
      var(--secondary-colour) 0%,
      var(--primary-colour) 100%
    );

    p:not(.eyebrow) {
      margin: 0;
      font-size: 1.1rem;
      line-height: 1.8;
      color: var(--text-colour);
    }
  }

  .team-image-panel {
    min-height: 26rem;
    background-color: var(--secondary-colour);
  }
}

.timeline-section {
  margin: 1.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .section-heading {
    max-width: 42rem;

    h2 {
      margin: 0.5rem 0 0;
    }
  }
}

.timeline-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.25rem;
}

.timeline-card {
  display: flex;
  flex-direction: column;
  background-color: var(--secondary-colour);
  transition: transform 200ms ease, border-color 200ms ease;

  &:hover {
    transform: translateY(-0.35rem);
    border-color: var(--action-colour);
  }

  .timeline-image {
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    display: block;
  }

  .timeline-copy {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.5rem;

    .timeline-step {
      margin: 0;
      font-size: 0.85rem;
      font-weight: 700;
      letter-spacing: 0.14em;
      color: var(--action-colour);
    }

    h3 {
      margin: 0;
      font-size: 1.35rem;
      line-height: 1.2;
      font-weight: 500;
    }

    p:last-child {
      margin: 0;
      font-size: 1rem;
      line-height: 1.7;
    }
  }
}

@media only screen and (max-width: 1100px) {
  .about-page {
    padding: 2rem 2rem 4rem;
  }

  .story-section {
    grid-template-columns: 1fr;

    .image-panel {
      min-height: 22rem;
    }
  }

  .team-section {
    grid-template-columns: 1fr;

    .team-image-panel {
      min-height: 22rem;
    }
  }

  .timeline-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media only screen and (max-width: 700px) {
  .about-page {
    padding: 1rem 1rem 3rem;
    gap: 1.25rem;
  }

  .hero {
    .hero-panel {
      min-height: 16rem;
      padding: 1.25rem;
    }
  }

  .story-section {
    gap: 1rem;

    .image-panel {
      min-height: 18rem;
    }
  }

  .team-section {
    gap: 1rem;

    .team-image-panel {
      min-height: 18rem;
    }

    .copy-panel {
      padding: 1.5rem;

      p:not(.eyebrow) {
        font-size: 1rem;
      }
    }
  }

  .timeline-grid {
    grid-template-columns: 1fr;
  }
}
</style>
